import React from "react";

type Props = {
  className?: string;
  fill?: string;
};

const PersonalizedRecommendations: React.FC<Props> = ({ className, fill }) => (
  <svg
    className={className}
    width="340"
    height="300"
    viewBox="0 0 340 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_297_3820)">
      <path
        d="M215.099 299.238C215.099 299.238 209.888 284.66 225.521 273.727L215.099 299.238Z"
        fill="#E6E6E6"
      />
      <path
        d="M208.69 298.974C208.69 298.974 207.1 288.583 194.796 288.672L208.69 298.974Z"
        fill="#E6E6E6"
      />
      <path
        d="M326.231 299.235C326.231 299.235 319.346 279.976 340 265.531L326.231 299.235Z"
        fill="#E6E6E6"
      />
      <path
        d="M317.763 298.883C317.763 298.883 315.663 285.156 299.408 285.274L317.763 298.883Z"
        fill="#E6E6E6"
      />
      <path
        d="M197.461 83.3883L190.662 79.284L191.17 78.9766L197.97 83.0814L197.461 83.3883Z"
        fill="#CBCBCB"
      />
      <path
        d="M191.53 83.3883L191.021 83.0814L197.82 78.9766L198.329 79.284L191.53 83.3883Z"
        fill="#CBCBCB"
      />
      <path
        d="M140.924 51.577L140.596 52.3047L142.516 53.4232L142.845 52.6955L140.924 51.577Z"
        fill="#CBCBCB"
      />
      <path
        d="M180.748 75.6868L176.924 73.4605L177.253 72.7327L181.076 74.9591L180.748 75.6868ZM173.101 71.2341L169.278 69.0076L169.606 68.2799L173.429 70.5064L173.101 71.2341ZM165.455 66.7813L161.632 64.555L161.96 63.8272L165.783 66.0535L165.455 66.7813ZM157.809 62.3286L153.986 60.1023L154.314 59.3745L158.137 61.6009L157.809 62.3286ZM150.163 57.8759L146.34 55.6496L146.668 54.9219L150.491 57.1482L150.163 57.8759Z"
        fill="#CBCBCB"
      />
      <path
        d="M184.898 77.1864L184.57 77.9141L186.491 79.0326L186.819 78.3049L184.898 77.1864Z"
        fill="#CBCBCB"
      />
      <path
        d="M39.8715 106.313C39.8715 106.568 39.8642 106.821 39.8496 107.072C39.768 108.521 39.446 109.938 38.9008 111.251C38.8965 111.262 38.8916 111.272 38.8874 111.283C38.862 111.343 38.8359 111.404 38.8092 111.464C38.647 111.835 38.4671 112.196 38.2703 112.545C37.3712 114.146 36.1389 115.471 34.6822 116.403C33.2256 117.335 31.5894 117.844 29.9184 117.886L30.0191 124.47L31.3329 123.684L31.5675 124.191L30.029 125.111L30.2171 137.339L30.2192 137.503L29.2034 137.76L29.2055 137.595L29.5253 117.887C28.1803 117.865 26.8525 117.54 25.619 116.93C24.3855 116.32 23.2709 115.438 22.34 114.334C22.2759 114.259 22.2125 114.181 22.1505 114.105L22.1434 114.096C21.3678 113.134 20.7405 112.031 20.2879 110.833C20.2978 110.845 20.3084 110.857 20.3182 110.87C19.2955 108.152 19.2261 105.093 20.1244 102.319C21.0226 99.5446 22.8203 97.2658 25.1493 95.9494C25.1845 95.9294 25.2204 95.9102 25.2557 95.8902C27.5594 94.6291 30.196 94.3977 32.6428 95.2419C35.0896 96.086 37.168 97.9441 38.4661 100.448C38.5281 100.566 38.588 100.687 38.6458 100.809C39.4521 102.498 39.8735 104.391 39.8715 106.313Z"
        fill="#FCC015"
      />
      <path
        d="M38.5004 111.285C45.8745 111.285 51.8524 104.492 51.8524 96.1113C51.8524 87.731 45.8745 80.9375 38.5004 80.9375C31.1263 80.9375 25.1484 87.731 25.1484 96.1113C25.1484 104.492 31.1263 111.285 38.5004 111.285Z"
        fill="#FCC015"
      />
      <path
        opacity="0.2"
        d="M28.6415 85.9766C27.3961 89.2874 27.2271 92.9936 28.1649 96.4329C29.1026 99.8723 31.0859 102.821 33.7604 104.751C36.4348 106.682 39.6262 107.469 42.7642 106.971C45.9022 106.474 48.7823 104.725 50.8899 102.036C50.1291 104.059 48.9904 105.869 47.5527 107.342C46.115 108.815 44.4127 109.916 42.5638 110.567C40.7148 111.218 38.7634 111.404 36.8448 111.113C34.9261 110.822 33.086 110.061 31.4521 108.881C29.8181 107.702 28.4294 106.133 27.382 104.283C26.3346 102.433 25.6536 100.346 25.3863 98.1674C25.1189 95.9887 25.2716 93.77 25.8337 91.665C26.3958 89.56 27.3538 87.619 28.6415 85.9766Z"
        fill="black"
      />
      <path
        d="M39.2225 138.381L37.8589 137.946L37.8617 137.779L38.2704 112.539L38.2908 111.281L38.2912 111.244L38.3627 106.834L38.4661 100.443L38.5364 96.1094H38.574L38.6459 100.803L38.7395 106.912L38.8065 111.247V111.279L38.8094 111.458L38.9389 119.908L38.9524 120.748L39.2201 138.212L39.2225 138.381Z"
        fill="#3F3D56"
      />
      <path
        d="M40.6603 118.883L38.4531 120.203L38.7607 120.867L40.9678 119.547L40.6603 118.883Z"
        fill="#3F3D56"
      />
      <path
        d="M211.581 47.0018C194.729 45.8696 177.826 46.1648 161.012 47.8852C152.908 48.7177 144.675 49.6169 136.72 51.6258C130.314 53.244 122.878 55.9789 118.886 62.3489C118.05 63.6324 117.486 65.1183 117.24 66.6904C116.993 68.2625 117.069 69.8781 117.464 71.4109C118.415 75.0422 120.783 78.0649 123.305 80.4324C129.109 85.8812 136.31 89.0519 142.742 93.3809C154.486 101.285 165.235 111.938 172.134 125.471C175.17 131.426 178.057 139.344 174.677 145.906C171.365 152.335 163.972 154.55 157.943 155.594C150.387 156.903 142.603 156.548 135.014 155.815C126.695 154.933 118.422 153.556 110.23 151.69C94.1805 148.187 78.2774 143.732 62.005 141.706C53.846 140.616 45.6182 140.345 37.4173 140.898C30.011 141.466 22.5412 142.797 15.5835 145.832C10.222 148.171 4.50694 151.709 1.61086 157.61C-1.18082 163.299 -0.0919757 169.858 2.94782 175.107C6.60532 181.421 12.3087 185.748 18.2383 188.911C24.9897 192.512 32.2109 194.846 39.4414 196.831C43.1085 197.838 46.7954 198.748 50.4827 199.654C51.2519 199.843 51.5806 198.5 50.8086 198.31C43.3729 196.484 35.9157 194.652 28.6647 192.009C21.9546 189.563 15.0877 186.43 9.59281 181.294C5.14739 177.138 0.920719 171.069 1.18311 164.168C1.44762 157.212 6.58343 152.355 11.6172 149.365C17.9081 145.629 25.0554 143.809 32.0589 142.858C40.078 141.843 48.1651 141.718 56.2056 142.485C72.4395 143.889 88.3107 148.091 104.227 151.757C119.69 155.318 135.636 158.616 151.482 157.702C157.763 157.34 164.493 156.317 170.039 152.714C172.578 151.065 174.867 148.739 176.158 145.711C177.32 142.831 177.688 139.618 177.212 136.495C176.313 129.636 172.728 123.276 169.151 117.813C165.23 111.887 160.682 106.533 155.609 101.871C150.042 96.7788 144.039 92.3347 137.69 88.6051C134.324 86.5908 130.91 84.6539 127.701 82.3209C124.625 80.0839 121.591 77.3924 119.712 73.761C118.088 70.6201 117.79 67.0354 119.482 63.8499C121.194 60.628 124.143 58.3809 127.051 56.7388C134.057 52.7825 142.203 51.7235 149.869 50.6383C166.329 48.3163 182.917 47.3764 199.498 47.8262C203.529 47.9339 207.556 48.1235 211.581 48.395C212.369 48.4477 212.367 47.0543 211.581 47.0018Z"
        fill="black"
      />
      <path
        d="M200.89 2.34619L203.436 0.0324042C201.458 -0.215546 200.646 1.01013 200.313 1.98027C198.768 1.25121 197.086 2.20667 197.086 2.20667L202.18 4.30799C201.923 3.52805 201.475 2.84752 200.89 2.34619Z"
        fill="#3F3D56"
      />
      <path
        d="M188.536 9.67431L191.082 7.36053C189.104 7.11258 188.292 8.33825 187.959 9.30838C186.414 8.57933 184.732 9.5348 184.732 9.5348L189.826 11.6361C189.569 10.8562 189.121 10.1756 188.536 9.67431Z"
        fill="#3F3D56"
      />
      <path
        d="M200.89 21.2681L203.436 18.9543C201.458 18.7063 200.646 19.932 200.313 20.9021C198.768 20.1731 197.086 21.1285 197.086 21.1285L202.18 23.2299C201.923 22.4499 201.475 21.7694 200.89 21.2681Z"
        fill="#3F3D56"
      />
      <path
        d="M162.728 24.6976C166.964 24.6976 170.398 20.7954 170.398 15.9816C170.398 11.1679 166.964 7.26562 162.728 7.26562C158.492 7.26562 155.059 11.1679 155.059 15.9816C155.059 20.7954 158.492 24.6976 162.728 24.6976Z"
        fill="#FCC015"
      />
      <path
        d="M186.779 42.8364H149.154C149.107 42.8371 149.06 42.8328 149.013 42.8237L166.808 7.797C166.917 7.57881 167.074 7.39728 167.265 7.27098C167.456 7.14468 167.672 7.07812 167.893 7.07812C168.113 7.07812 168.33 7.14468 168.52 7.27098C168.711 7.39728 168.868 7.57881 168.977 7.797L180.919 31.3019L181.491 32.4264L186.779 42.8364Z"
        fill={fill}
      />
      <path
        d="M207.726 42.8358H175.185L181.49 32.4266L181.944 31.6765L190.161 18.1116C190.306 17.904 190.488 17.7336 190.695 17.6113C190.902 17.489 191.13 17.4176 191.363 17.4018C191.596 17.386 191.829 17.4261 192.047 17.5195C192.266 17.6129 192.464 17.7575 192.63 17.944C192.673 17.9969 192.713 18.0529 192.749 18.1116L207.726 42.8358Z"
        fill={fill}
      />
      <path
        d="M154.047 123.172C157.613 125.198 159.784 127.873 159.784 130.807C159.784 137.129 149.719 142.253 137.303 142.253C131.905 142.253 126.953 141.284 123.077 139.669C127.193 142.007 133.168 143.48 139.821 143.48C152.237 143.48 162.302 138.355 162.302 132.034C162.302 128.461 159.085 125.271 154.047 123.172Z"
        fill="#F1F1F1"
      />
      <path
        d="M161.979 127.516C166.004 129.801 168.453 132.82 168.453 136.131C168.453 143.264 157.096 149.047 143.086 149.047C136.995 149.047 131.407 147.953 127.034 146.131C131.678 148.769 138.421 150.43 145.927 150.43C159.937 150.43 171.295 144.648 171.295 137.515C171.295 133.483 167.665 129.884 161.979 127.516Z"
        fill="#F1F1F1"
      />
      <path
        d="M151.011 125.086C153.523 126.513 155.053 128.398 155.053 130.465C155.053 134.919 147.962 138.529 139.214 138.529C135.807 138.579 132.416 137.964 129.192 136.709C132.092 138.356 136.301 139.393 140.988 139.393C149.736 139.393 156.827 135.783 156.827 131.329C156.827 128.812 154.561 126.565 151.011 125.086Z"
        fill="#F1F1F1"
      />
      <path
        d="M115.708 124.266C115.708 124.266 116.261 133.437 132.087 133.437C147.914 133.437 152.639 124.266 152.639 124.266H115.708Z"
        fill="#3F3D56"
      />
      <path
        d="M138.173 100.205C135.888 98.2324 133.02 97.3409 130.17 97.7172C132.717 98.4151 134.967 100.11 136.524 102.505C138.081 104.9 138.846 107.841 138.685 110.813C138.524 113.785 137.447 116.598 135.643 118.757C133.839 120.917 131.424 122.285 128.82 122.622C131.31 123.305 133.931 122.993 136.243 121.739C138.554 120.484 140.415 118.363 141.513 115.733C142.61 113.103 142.877 110.123 142.269 107.295C141.661 104.467 140.214 101.964 138.173 100.205Z"
        fill="#3F3D56"
      />
      <path
        d="M132.987 96.0625H131.908V125.254H132.987V96.0625Z"
        fill="#3F3D56"
      />
      <path
        d="M203.905 74.3724L203.899 74.3611L203.884 73.6481L207.265 68.0701L203.888 73.1144L203.876 73.2651L203.761 67.5637L206.681 61.7806L203.752 66.5621L203.783 54.7503L203.783 54.7109L203.782 54.7496L203.588 64.0589L200.927 60.2775L203.579 64.8609L203.521 69.9607L201.072 64.9835L203.512 70.7105L203.48 73.5462L203.39 81.4025L203.384 81.9896C203.609 81.9915 203.833 81.9873 204.054 81.9768L203.9 74.4306L203.905 74.3724Z"
        fill="#CBCBCB"
      />
      <path
        d="M187.718 76.8255L187.712 76.8143L187.698 76.1012L191.078 70.5232L187.702 75.5675L187.69 75.7182L187.574 70.0168L190.494 64.2337L187.566 69.0152L187.596 57.2034L187.596 57.1641L187.595 57.2027L187.401 66.5121L184.74 62.7306L187.393 67.3141L187.335 72.4138L184.886 67.4367L187.326 73.1636L187.293 75.9993L187.204 83.8556L187.197 84.4427C187.423 84.4446 187.646 84.4404 187.867 84.4299L187.714 76.8838L187.718 76.8255Z"
        fill="#CBCBCB"
      />
      <path
        d="M195.632 69.0599L195.626 69.0486L195.611 68.3356L198.992 62.7576L195.615 67.8019L195.603 67.9526L195.488 62.2512L198.408 56.4681L195.479 61.2496L195.51 49.4378L195.51 49.3984L195.509 49.4371L195.315 58.7464L192.654 54.965L195.306 59.5484L195.248 64.6482L192.799 59.671L195.239 65.398L195.207 68.2337L195.117 76.09L195.111 76.6771C195.336 76.679 195.56 76.6747 195.781 76.6643L195.627 69.1181L195.632 69.0599Z"
        fill="#CBCBCB"
      />
      <path
        d="M61.9458 204.795C64.3297 204.795 66.2622 202.599 66.2622 199.89C66.2622 197.181 64.3297 194.984 61.9458 194.984C59.5619 194.984 57.6294 197.181 57.6294 199.89C57.6294 202.599 59.5619 204.795 61.9458 204.795Z"
        fill={fill}
      />
      <path
        d="M292.34 290.438L288.344 292.126L280.716 275.412L286.614 272.922L292.34 290.438Z"
        fill="#FFB7B7"
      />
      <path
        d="M294.799 294.416L281.914 299.857L281.853 299.671C281.359 298.16 281.414 296.487 282.005 295.021C282.596 293.555 283.675 292.416 285.005 291.854L292.875 288.531L294.799 294.416Z"
        fill="#2F2E41"
      />
      <path
        d="M253.014 295.156L248.751 295.155L246.723 276.469L253.015 276.469L253.014 295.156Z"
        fill="#FFB7B7"
      />
      <path
        d="M253.754 299.856L240.008 299.856V299.658C240.008 298.046 240.572 296.499 241.575 295.359C242.579 294.219 243.94 293.578 245.358 293.578L253.754 293.579L253.754 299.856Z"
        fill="#2F2E41"
      />
      <path
        d="M272.532 165.56L271.141 162.398L259.318 169.116L259.666 171.882L257.406 175.241C257.406 175.241 253.581 177.612 254.276 185.516L254.972 193.024L255.841 202.705L249.756 226.613L246.626 258.226L244.366 283.714L255.319 283.121L265.403 241.629L283.137 286.283L295.307 282.726L278.617 238.468L276.53 219.895C276.53 219.895 277.921 210.016 271.315 203.298L272.358 199.742V195.359L275.835 174.451L272.532 165.56Z"
        fill="#2F2E41"
      />
      <path
        opacity="0.2"
        d="M272.857 210.74L265.207 241.562L265.6 241.689L273.25 210.866L272.857 210.74Z"
        fill="black"
      />
      <path
        d="M272.184 202.703H255.146V204.679H272.184V202.703Z"
        fill="#3F3D56"
      />
      <path
        d="M255.146 205.866C255.53 205.866 255.841 204.981 255.841 203.89C255.841 202.799 255.53 201.914 255.146 201.914C254.762 201.914 254.45 202.799 254.45 203.89C254.45 204.981 254.762 205.866 255.146 205.866Z"
        fill="#3F3D56"
      />
      <path
        d="M267.275 160.448C271.767 157.658 273.418 151.258 270.962 146.153C268.507 141.049 262.875 139.173 258.384 141.963C253.892 144.754 252.241 151.154 254.697 156.258C257.152 161.363 262.784 163.239 267.275 160.448Z"
        fill="#FFB7B7"
      />
      <path
        d="M277.013 147.449C281.541 147.449 285.212 143.277 285.212 138.131C285.212 132.985 281.541 128.812 277.013 128.812C272.484 128.812 268.813 132.985 268.813 138.131C268.813 143.277 272.484 147.449 277.013 147.449Z"
        fill="#2F2E41"
      />
      <path
        d="M287.418 137.133C287.742 138.367 287.836 139.665 287.696 140.943C287.556 142.222 287.184 143.453 286.604 144.56C286.024 145.667 285.249 146.625 284.326 147.374C283.404 148.123 282.355 148.646 281.246 148.911C280.137 149.176 278.991 149.177 277.881 148.914C276.772 148.65 275.722 148.128 274.799 147.38C273.876 146.632 273.1 145.675 272.519 144.569C271.937 143.463 271.564 142.232 271.423 140.954C272.01 143.196 273.318 145.105 275.087 146.301C276.855 147.498 278.955 147.895 280.969 147.414C282.983 146.933 284.764 145.608 285.959 143.704C287.154 141.799 287.675 139.454 287.418 137.133Z"
        fill="#2F2E41"
      />
      <path
        d="M255.024 148.282C254.784 150.691 255.249 153.123 256.348 155.201C257.447 157.278 259.118 158.886 261.102 159.775C263.087 160.664 265.274 160.784 267.325 160.117C269.375 159.45 271.175 158.033 272.446 156.086C273.716 154.138 274.385 151.769 274.351 149.345C274.316 146.921 273.578 144.578 272.253 142.679C270.927 140.78 269.088 139.43 267.019 138.84C264.95 138.249 262.767 138.451 260.809 139.413C259.19 137.929 257.183 138.389 255.55 139.955C253.705 141.726 253.157 142.942 251.726 145.855C253.133 146.079 253.617 148.058 255.024 148.282Z"
        fill="#2F2E41"
      />
      <path
        d="M289.094 179.96C288.991 183.082 288.785 189.226 288.785 189.54C288.785 189.87 284.686 199.515 282.915 203.666V203.668C282.789 203.961 282.676 204.226 282.576 204.46C282.439 204.782 282.224 205.053 281.956 205.24C281.688 205.427 281.378 205.523 281.063 205.516L273.324 205.358C272.899 205.35 272.493 205.156 272.191 204.815C271.889 204.475 271.714 204.015 271.704 203.531L270.841 164.84C270.838 164.713 270.857 164.586 270.898 164.467C270.939 164.348 271.001 164.24 271.079 164.148C271.158 164.057 271.251 163.984 271.355 163.935C271.458 163.885 271.569 163.859 271.682 163.859H281.661C282.083 163.86 282.496 163.995 282.853 164.249C283.21 164.504 283.497 164.868 283.68 165.299L288.47 176.561C288.919 177.619 289.133 178.786 289.094 179.96Z"
        fill={fill}
      />
      <path
        d="M271.569 200.874C269.583 199.507 267.799 197.793 266.281 195.796C262.755 191.289 260.611 185.604 260.17 179.594C259.777 174.452 260.674 170.63 262.838 168.234C265.589 165.188 269.334 165.63 269.492 165.651L269.659 165.672L272.196 168.112L271.478 169.076L269.208 166.893C268.514 166.854 265.677 166.845 263.605 169.148C261.698 171.268 260.915 174.746 261.277 179.485C261.697 185.207 263.733 190.621 267.083 194.92C268.528 196.82 270.222 198.455 272.105 199.768L271.569 200.874Z"
        fill={fill}
      />
      <path
        d="M285.97 186.172L272.448 189.328L272.523 189.74L286.044 186.584L285.97 186.172Z"
        fill="#3F3D56"
      />
      <path
        d="M277.058 163.85L276.688 163.867L277.566 188.318L277.936 188.301L277.058 163.85Z"
        fill="#3F3D56"
      />
      <path
        d="M289.095 179.956C288.991 183.078 288.785 189.222 288.785 189.536C288.785 189.866 284.686 199.511 282.916 203.662L286.216 181.882C286.344 181.044 286.665 180.26 287.147 179.609C287.629 178.959 288.254 178.465 288.959 178.18C289.07 178.763 289.116 179.36 289.095 179.956Z"
        fill="#3F3D56"
      />
      <path
        d="M268.815 225.605C269.107 225.177 269.314 224.682 269.419 224.153C269.524 223.625 269.527 223.077 269.426 222.548C269.325 222.018 269.123 221.52 268.834 221.089C268.545 220.658 268.177 220.304 267.755 220.053L268.426 211.619L264.015 209.906L263.215 221.831C262.89 222.664 262.845 223.605 263.089 224.474C263.334 225.343 263.85 226.079 264.54 226.545C265.23 227.01 266.047 227.171 266.835 226.998C267.623 226.825 268.327 226.329 268.815 225.605Z"
        fill="#FFB7B7"
      />
      <path
        d="M269.392 217.443L261.577 217.121L261.908 174.294C261.902 173.082 262.232 171.898 262.85 170.911C263.469 169.924 264.344 169.182 265.354 168.791C266.297 168.435 267.317 168.434 268.26 168.788C269.331 169.2 270.25 170.005 270.873 171.077C271.497 172.148 271.788 173.425 271.702 174.706L269.392 217.443Z"
        fill="#CBCBCB"
      />
      <path
        d="M337.946 299.999H182.254C182.145 299.999 182.042 299.95 181.965 299.863C181.888 299.776 181.845 299.658 181.845 299.535C181.845 299.412 181.888 299.293 181.965 299.206C182.042 299.119 182.145 299.07 182.254 299.07H337.946C338.054 299.07 338.158 299.119 338.235 299.206C338.311 299.293 338.354 299.412 338.354 299.535C338.354 299.658 338.311 299.776 338.235 299.863C338.158 299.95 338.054 299.999 337.946 299.999Z"
        fill="#CBCBCB"
      />
    </g>
    <defs>
      <clipPath id="clip0_297_3820">
        <rect width="340" height="300" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PersonalizedRecommendations;
